import {
  IModalidades,
  INumeroExtracto,
  ISorteo,
} from "../interfaces/interfaces";
import { saveAs } from "file-saver";
const baseUrl = `${process.env.REACT_APP_API_EXTRACTOS ?? ""}`;
const baseUrlPdf = `https://servicios.iafas.gov.ar/serviciopdf`;
const token = `${process.env.REACT_APP_API_TOKEN ?? ""}`;

export async function LastExtractos(params: { id: number }) {
  try {
    const { id } = params;
    let url = `${baseUrl}/UltimoEncabezado`;

    let myHeaders = new Headers();

    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);

    let requestOptions = {
      headers: myHeaders,
      method: "POST",
    };

    if (id === 2) {
      //modalidades
      url = `${baseUrl}/UltimoEncabezado02`;
    }

    let res = await fetch(`${url}`, requestOptions);

    let data = (await res.json()) as IModalidades[];

    if (res.status === 200) {
      return { message: "heads", data: data, status: 200 };
    } else {
      return { message: "heads", data: [] as IModalidades[], status: 200 };
    }
  } catch (error) {
    console.log("error", error);
    return { message: "error heads", data: [] as IModalidades[], status: 500 };
  }
}

export async function GetExtractosLast() {
  try {
    let myHeaders = new Headers();

    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);

    let items = await LastExtractos({ id: 1 }); // items - headExtractos
    let modalidades = await LastExtractos({ id: 2 }); // modalidades

    let encabezado: IModalidades[] = [];

    const { data } = modalidades;

    encabezado = [
      ...data.map((modalidad) => {
        const item = items.data.filter(
          (val) => val.idModalidad === modalidad.idModalidad
        );

        return {
          NROSorteo: parseInt(`${modalidad.NROSorteo}`),
          FechaSorteo: modalidad.FechaSorteo,
          FechaSorteoLetras: modalidad.FechaSorteoLetras,
          Modalidad: modalidad.Modalidad,
          idModalidad: parseInt(`${modalidad.idModalidad}`),
          FechaSorteoSTR: modalidad.FechaSorteoSTR,
          FechaPrescripcion: modalidad.FechaPrescripcion,
          items: [...item],
        };
      }),
    ];

    return {
      message: "heads",
      data: [...encabezado],
      status: 200,
    };
  } catch (error) {
    console.log("error", error);
    return {
      message: "error heads",
      data: [],
      status: 500,
    };
  }
}

export async function GetNumbersExtractosLast() {
  try {
    let url = `${baseUrl}/ultimoExtracto`;
    let myHeaders = new Headers();

    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);

    let requestOptions = {
      headers: myHeaders,
      method: "POST",
    };

    let res = await fetch(`${url}`, requestOptions);

    let data = (await res.json()) as INumeroExtracto[];

    if (res.status === 200) {
      return { message: "numbers", data: data, status: 200 };
    } else {
      return { message: "numbers", data: [], status: 200 };
    }
  } catch (error) {
    console.log("error", error);
    return {
      message: "error numbers",
      data: [],
      status: 500,
    };
  }
}

export async function GetSorteos(params: {
  fechaDesde: string;
  fechaHasta: string;
  estado: string;
}) {
  try {
    const { fechaDesde, fechaHasta, estado } = params;
    const MODALIDAD = "";
    const SORTEO = "";
    let url = `${baseUrl}/Sorteos`;

    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);

    const form = {
      fechaDesde: fechaDesde,
      fechaHasta: fechaHasta,
      Modalidad: MODALIDAD,
      Sorteo: SORTEO,
      Estado: estado,
    };

    let requestOptions = {
      headers: myHeaders,
      method: "POST",
      body: JSON.stringify(form),
    };

    let res = await fetch(`${url}`, requestOptions);
    let data = (await res.json()) as any[];

    if (res.status === 200) {
      let sorteos = data[0] && data[0].length > 0 ? (data[0] as ISorteo[]) : [];
      return {
        message: "heads",
        data: [...sorteos],
        status: 200,
      };
    } else {
      return { message: "heads", data: [] as ISorteo[], status: 200 };
    }
  } catch (error) {
    console.log("error", error);
    return { message: "error heads", data: [] as ISorteo[], status: 500 };
  }
}

export async function GetPDFSorteo(
  id: number,
  cantLoteria: number,
  NroSorteo: number,
  modalidad: number,
  fecha: string
) {
  const NroLoteria = "";
  try {
    let pdf = await getPDFSorteos(
      modalidad,
      NroLoteria,
      NroSorteo,
      fecha,
      cantLoteria
    );
    const Extractos = new Blob([pdf], { type: "application/pdf" });
    const url = URL.createObjectURL(Extractos);
    return url;
  } catch (error) {
    console.log("err", error);
    return "error pdf";
  }
}

export async function DescargarPDF(
  id: number,
  cantLoteria: number,
  NroSorteo: number,
  modalidad: number,
  fecha: string
) {
  const NroLoteria = "";
  try {
    let pdf = await getPDFSorteos(
      modalidad,
      NroLoteria,
      NroSorteo,
      fecha,
      cantLoteria
    );
    const Extractos = new Blob([pdf], { type: "application/pdf" });
    const url = window.URL.createObjectURL(Extractos);
    return saveAs(url, "Extracto" + NroSorteo);
  } catch (error) {
    return "error pdf";
  }
}

export async function getPDFSorteos(
  Modalidad: number,
  NroLoteria: string,
  Sorteo: number,
  FechaSorteo: string,
  cantidad: number
) {
  try {
    let path = "";
    if (Modalidad === 30) {
      path = "pdfpoceada";
    } else {
      if (cantidad === 4) {
        path = "pdf1";
      } else if (cantidad === 5) {
        path = "pdf3";
      } else if (cantidad === 6) {
        path = "pdf4";
      } else {
        path = "pdf2";
      }
    }

    let url = `${baseUrlPdf}/Extractos/${path}`;

    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);

    const form = {
      Modalidad: Modalidad,
      NroLoteria: NroLoteria,
      Sorteo: Sorteo,
      FechaSorteo: FechaSorteo,
    };

    let requestOptions = {
      headers: myHeaders,
      method: "POST",
      body: JSON.stringify(form),
    };

    let res = await fetch(`${url}`, requestOptions);

    return await res.arrayBuffer();
  } catch (error) {
    return "";
  }
}

export function AddCerosToNumber(valor: number, cantidad: number) {
  let val = `${valor}`;
  let mascarado = "";

  if (val.length < cantidad) {
    let i = 0;

    let j = cantidad - val.length; // la diferencia

    while (i < j) {
      mascarado = "0" + mascarado; // acumular ceros
      i++;
    }

    mascarado = mascarado + val; // concateno con el numero
    return mascarado;
  } else {
    return valor;
  }
}

export function SubFirstCaracter(valor: number | string) {
  let val = `${valor}`;
  return val.slice(1);
}

export function filtrarNombresUnicos(
  array: INumeroExtracto[]
): { id: number; Nombre: string }[] {
  const nombresUnicos = new Map<string, { id: number; Nombre: string }>();

  array.forEach((item) => {
    if (!nombresUnicos.has(item.Nombre)) {
      nombresUnicos.set(item.Nombre, {
        id: item.NroLoteria,
        Nombre: item.Nombre,
      });
    }
  });

  // Orden de loterías conocidas (orden preferido)
  const IDS = [1, 5, 6, 2, 3, 4];
  const idToIndexMap: { [key: number]: number } = {};

  // Crear un objeto de mapeo de IDs a índices
  IDS.forEach((id, index) => {
    idToIndexMap[id] = index;
  });

  return Array.from(nombresUnicos.values()).sort((a, b) => {
    const indexA = idToIndexMap[a.id];
    const indexB = idToIndexMap[b.id];

    // Si ambos IDs no están en el orden conocido, ordenar por ID ascendente
    if (indexA === undefined && indexB === undefined) {
      return a.id - b.id;
    }
    
    // Si solo uno no está en el orden conocido, ponerlo al final
    if (indexA === undefined) return 1; // a va después de b
    if (indexB === undefined) return -1; // a va antes de b
    
    // Ambos están en el orden conocido, usar ese orden
    return indexA - indexB;
  });
}
